export default __webpack_public_path__ + "dde46ad2344ae4997f9f4c66f5f9f906.svg";